import UserResourceModel from '../../generated/types/model/resource/UserResourceModel';

export default class UserResourceViewModel extends UserResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
